/* eslint-disable react/prop-types */

export function NextIcon({ color = '#ffffff' }) {
  return (
    <svg
      viewBox='0 0 42 42'
      width='42'
      height='42'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 29L29 21M29 21L21 13M29 21L13 21M21 41C9.9543 41 0.999999 32.0457 0.999999 21C1 9.9543 9.9543 0.999999 21 0.999999C32.0457 1 41 9.9543 41 21C41 32.0457 32.0457 41 21 41Z'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function PrevIcon({ color = '#ffffff' }) {
  return (
    <svg
      viewBox='0 0 42 42'
      width='42'
      height='42'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 13L13 21M13 21L21 29M13 21L29 21M21 0.999999C32.0457 0.999999 41 9.9543 41 21C41 32.0457 32.0457 41 21 41C9.9543 41 1 32.0457 0.999999 21C0.999999 9.9543 9.9543 1 21 0.999999Z'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function Arrow({ color = '#ffffff' }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='15' viewBox='0 0 14 15' fill='none'>
      <path d='M7 13.5L13 7.5M13 7.5L7 1.5M13 7.5L1 7.5' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function PlayIcon({ color = '#ffffff' }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='90' height='90' viewBox='0 0 90 90' fill='none'>
      <path d='M45 82.5C65.7107 82.5 82.5 65.7107 82.5 45C82.5 24.2893 65.7107 7.5 45 7.5C24.2893 7.5 7.5 24.2893 7.5 45C7.5 65.7107 24.2893 82.5 45 82.5Z' stroke={color} strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M37.5 30L60 45L37.5 60V30Z' stroke={color} strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function DownloadIcon({ color = '#ffffff' }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M5 8L10 13M10 13L15 8M10 13V1' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>

  );
}
